<template>
  <div class="sidebar sidebar-style-2">
    <div class="sidebar-wrapper scrollbar scrollbar-inner">
      <div class="sidebar-content">
        <div class="user">
          <div class="info my-2">
            <div class="m-t-lg text-center">
              <router-link to="/user/credits" class="btn btn-warning btn-rounded btn-sm" tag="button" type="button">
                <span class="text-dark">{{ $t('credits') }}: </span> <span class="strong text-dark">{{ credits }}</span>
                <img src="/static/img/credit-coins.png" alt="coins" class="ml-2 credit-coins">
              </router-link>
            </div>
          </div>
        </div>
        <ul class="nav nav-primary">
          <li class="text-dark m-3 text-small">
            <span>Main Menu</span>
            </li>
          <li class="nav-item" :class="{ active: currentPage === 'Campaigns' }">
            <router-link to="/campaigns">
              <i class="fa fa-bullhorn text-warning"></i>
              <p>{{ $t('campaigns') }}</p>
            </router-link>
          </li>
          <li class="nav-item" :class="{ active: currentPage === 'MyCampaigns' }">
            <router-link to="/user/campaigns">
              <i class="fa fa-user text-info"></i>
              <p>{{ $t('my_campaigns') }}</p>
            </router-link>
          </li>
          <li class="nav-item" :class="{ active: currentPage === 'Playlists' }">
            <router-link to="/playlists">
              <i class="fa fa-list text-primary-ltest"></i>
              <p>Playlists</p>
            </router-link>
          </li>
          <li class="text-dark m-3 text-small"><span>User</span></li>
          <li class="nav-item" :class="{ active: currentPage === 'UserPlaylists' }" v-if="$user && $user.role === 'admin'">
            <router-link to="/user/playlists">
              <i class="fa fa-user text-primary-lter"></i>
              <span>{{ $t('my_playlists') }}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <a href="https://indiefy.net/">
              <i class="fa fa-sign-out-alt"></i>
              <p>Go to Indiefy</p>
            </a>
          </li>
          <li class="nav-item" @click="logout()">
            <a href="#">
              <i class="fa fa-sign-out-alt text-danger"></i>
              <span>
                {{ $t('logout') }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'

export default {
  name: 'Sidebar',
  data: function () {
    return {
      contains: _.contains,
      currentPage: this.$route.name,
      defaultImage: '/static/img/img-placeholder.jpg',
      user: null,
      credits: 0,
      showUserDropdown: false
    }
  },
  methods: {
    logout () {
      this.$http.get(`${window.apiURL}auth/logout`, { withCredentials: true }).then(response => {
        localStorage.removeItem('user')
        this.$user = {}
        this.refreshUser()
      })
    },
    getCredits () {
      this.$http.get(`${window.apiURL}api/user/credits`, { withCredentials: true }).then(response => {
        this.credits = response.data.available || 0
        this.$eventBus.$emit('creditsUpdated', { credits: this.credits, clicked: response.data.today_clicks })
      })
    },
    refreshUser () {
      this.$eventBus.$emit('refreshUser')
    }
  },
  watch: {
    '$route' (to, from) {
      this.currentPage = to.name
    }
  },
  created () {
    setTimeout(() => {
      this.refreshUser()

      if (localStorage.getItem('user')) {
        this.getCredits()
      }

      this.currentPage = this.$router.history.current.name
      this.$eventBus.$on('updateCredits', () => this.getCredits())
    }, 1)
  }
}
</script>
<style lang="scss" scoped>
  .credit-coins {
    width: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue